const {
  VITE_API_URL,
  VITE_RESOURCES_URL,
  VITE_DISCORD_CLIENT_ID,
  VITE_PLAUSIBLE_URL,
} = import.meta.env;

export const config = {
  API_URL: VITE_API_URL,
  RESOURCES_URL: VITE_RESOURCES_URL,
  DISCORD_CLIENT_ID: VITE_DISCORD_CLIENT_ID,
  PLAUSIBLE_URL: VITE_PLAUSIBLE_URL,
};

export const DEFAULT_LANGUAGE = "en";
